import { render, staticRenderFns } from "./updateAdmin.vue?vue&type=template&id=9a56b7ba&"
import script from "./updateAdmin.vue?vue&type=script&lang=js&"
export * from "./updateAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a56b7ba')) {
      api.createRecord('9a56b7ba', component.options)
    } else {
      api.reload('9a56b7ba', component.options)
    }
    module.hot.accept("./updateAdmin.vue?vue&type=template&id=9a56b7ba&", function () {
      api.rerender('9a56b7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/updateAdmin.vue"
export default component.exports